export function RatingsSectionSkeleton() {
  return (
    <div className="w-full md:px-4 px-2">
      <div className="h-7 w-[520px] max-w-full rounded bg-secondary" />
      <div className="mt-2 h-4 w-40 rounded bg-secondary" />
      <div className="mt-6 grid grid-cols-2 gap-6">
        <div className="h-8 rounded bg-secondary" />
        <div className="h-8 rounded bg-secondary" />
      </div>
      <div className="mt-6 h-px w-full bg-secondary" />
      <div className="mt-6 h-6 w-40 rounded bg-secondary" />
      <div className="mt-4 grid grid-cols-2 gap-6">
        <div className="h-16 rounded bg-secondary" />
        <div className="h-16 rounded bg-secondary" />
      </div>
      <div className="mt-6 h-px w-full bg-secondary" />
      <div className="mt-6 h-6 w-56 rounded bg-secondary" />
      <div className="mt-4 space-y-0">
        <div className="h-20 rounded bg-secondary" />
        <div className="mt-0 h-px w-full bg-secondary" />
        <div className="h-20 rounded bg-secondary" />
      </div>
    </div>
  );
}
